import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Set a component's draft model
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetComponentModel = packet => {
  return {
    type: 'REQUEST_SET_COMPONENT_MODEL',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetComponentModelSuccess = data => ({
  type: 'RECEIVE_SET_COMPONENT_MODEL_SUCCESS',
  data
})

export const receiveSetComponentModelFail = data => ({
  type: 'RECEIVE_SET_COMPONENT_MODEL_FAIL',
  data
})

export const tryToSetComponentModel = packet => (dispatch, getState) => {

  dispatch(requestSetComponentModel(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/draft/model/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetComponentModelSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSetComponentModelFail({errors:e, lastSubmit: packet}));
    })
}
